import { render, staticRenderFns } from "./DashboardCloseCockpit.vue?vue&type=template&id=74e3df3f&"
import script from "./DashboardCloseCockpit.vue?vue&type=script&lang=js&"
export * from "./DashboardCloseCockpit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports